import React, { ReactNode } from 'react';
import { AttentionBox } from '@p81-common/ui';
import { links } from '../../../../../../data/constants';
import { createClasses } from './styles';

interface WarningAttentionBoxProps {
  title: string;
  subtitle?: string;
  children?: ReactNode;
  /**
   * The error scheme is the same box in red, for a failure the operator has to
   * act on. The illustration is shared: it is the only alert asset this flow
   * ships, and it reads correctly either way.
   */
  colorScheme?: 'warning' | 'error';
}

const WarningAttentionBox = ({
  title,
  subtitle,
  children,
  colorScheme = 'warning'
}: WarningAttentionBoxProps) => {
  const classes = createClasses();

  return (
    <AttentionBox
      title={title}
      subtitle={subtitle ?? ''}
      colorScheme={colorScheme}
      iconUrl={`${links.imagesBaseUrl}/png/illus_OrgSec_alert.png`}
      classes={{
        title: classes.title,
        subtitle: classes.subtitle,
        buttons: classes.buttons,
        content: classes.root,
        contentInner: classes.contentInner,
        icon: classes.icon,
        titleContainer: classes.titleContainer,
        textContainer: classes.textContainer
      }}
    >
      {children}
    </AttentionBox>
  );
};

export default WarningAttentionBox;
